import { prefixZero } from '../../../util/date-time';
export function marketsTreasuryTransform(data, params) {
    const treasuries = [];
    const contentData = data.Data[0] || data.Data;
    if (contentData && contentData.DataPoints) {
        const dateItems = contentData.DataPoints;
        const timePeriods = params.timePeriods
            ? params.timePeriods.split(',')
            : Object.keys(dateItems);
        timePeriods.forEach(key => {
            const dataitem = dateItems[key];
            if (dataitem) {
                treasuries.push({
                    name: key,
                    value: serializeValue(dataitem)
                });
            }
        });
    }
    return treasuries;
}

export function marketsUsGovtTransform(data, params) {
    const bonds = data.bonds || [];
    let asOfDate = data.Date || ''; // M-DD-YYYY
    if (asOfDate) {
        const dateArray = asOfDate.split('-');
        if (dateArray.length === 3) {
            asOfDate = `${dateArray[2]}${prefixZero(dateArray[0])}${
                dateArray[1]
            }`;
        }
    }
    return bonds.map(bond => {
        return {
            governmentBondName: bond.name,
            closePrice: bond.LastPrice,
            changeAmount: bond.ChangeAmount,
            changePercent: bond.ChangePercent,
            asOfDate: asOfDate
        };
    });
}

function serializeValue(arry) {
    let strValue = JSON.stringify(arry);
    strValue = strValue
        .replace(/-/g, '')
        .replace(/\b[A-Z][a-zA-Z]/g, function(value) {
            return value.toLowerCase();
        });
    return JSON.parse(strValue);
}
